export type LanguageOption = {
  value: string;
  label: string;
};

export const GOOGLE_TRANSLATE_LANGUAGE_OPTIONS: LanguageOption[] = [
  { value: 'fr', label: 'French' },
  { value: 'de', label: 'German' },
  { value: 'nl', label: 'Dutch' },
  { value: 'ar', label: 'Arabic' },
  { value: 'es', label: 'Spanish' },
  { value: 'en', label: 'English' },
  { value: 'ja', label: 'Japanese' },
  { value: 'tr', label: 'Turkish' },
  { value: 'kk', label: 'Kazakh' },
  { value: 'mn', label: 'Mongolian' },
  { value: 'uz', label: 'Uzbek' },
  { value: 'az', label: 'Azerbaijani' },
  { value: 'da', label: 'Danish' },
  { value: 'no', label: 'Norwegian' },
];

export type GoogleTranslateLanguageCode = (typeof GOOGLE_TRANSLATE_LANGUAGE_OPTIONS)[number]['value'];

export const GOOGLE_TRANSLATE_LANGUAGE_LABEL_BY_CODE: Readonly<Record<string, string>> = Object.freeze(
  GOOGLE_TRANSLATE_LANGUAGE_OPTIONS.sort((a, b) => a.label.localeCompare(b.label)).reduce(
    (acc, cur) => {
      acc[cur.value] = cur.label;
      return acc;
    },
    {} as Record<string, string>,
  ),
);

export const LANGUAGE_CODE_SYNONYMS: Readonly<Record<string, GoogleTranslateLanguageCode>> = Object.freeze({});

export const GOOGLE_TRANSLATE_LANGUAGE_CODES: readonly GoogleTranslateLanguageCode[] =
  GOOGLE_TRANSLATE_LANGUAGE_OPTIONS.map((o) => o.value) as readonly GoogleTranslateLanguageCode[];
